import React, { useEffect, useState } from 'react';
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  IconButton,
  Accordion,
  AccordionDetails,
  Pagination,
  Grid,
  TableCell,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  Divider,
} from '@mui/material';
import { SimCardDownloadOutlined, DeleteOutline, Close,Visibility, GetApp,CloseOutlined } from '@mui/icons-material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { ButtonStyle, StyledTableCell, StyledTypeBox, ContainerStyle, ButtonStyleContainer, IpdActionCell } from '../../assets/styles/CommonStyles';
import { useStyles } from '../../assets/styles/TableStyles';
import { appointmentTabList, CURRENCIES, getBackgroundColor, getStatusText } from '../../constant/staticLists';
import { appointmentStyles } from '../../assets/styles/DoctorAppointmentStyles';
import TabComponent from '../Tab';
import "../../assets/styles/expendibleStyles.css";
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import strings from '../../constant/strings';
import defaultUserPng from "../../assets/img/user.png";
import { commonMuiStyles } from '../../assets/styles/CommonMUIStyles';
import { Button } from '@mui/base';
import colors from '../../constant/colors';
import { renderGender, renderPermission } from '../../utils/GenericFunctions';
import ChatInterface from '../Chat/ChatInterface';
import { socket } from '../../Socket';

const isTimeBetween = (startTime, endTime) => {
  const currentTime = moment.utc().format("HH:mm:ss.SSS");
  const startUTC = moment.utc(startTime, "HH:mm:ss.SSS").format("HH:mm:ss.SSS");
  const endUTC = moment.utc(endTime, "HH:mm:ss.SSS").format("HH:mm:ss.SSS");
  return currentTime >= startUTC && currentTime <= endUTC;
};

export const types = {
  1: 'Prescription',
  2: 'Report',
  3: 'Letter',
}

const mockUserData = {
  name: 'Dr. John Doe',
  specialization: 'Cardiology',
};
const mockPrescriptionItems = [
  { name: 'Amoxicillin', companyName: 'Pharma Co.', prescriptionType: 'structured', structuredDose: ['1', '0', '1', '0'], quantity: '20 tabs' },
  { name: 'Ibuprofen', companyName: 'Pain Away', prescriptionType: 'text', dosageType: 'Take as needed for pain.', quantity: null },
];
const mockNote = "Follow up in two weeks. Stay hydrated and avoid strenuous activity.";

const Tables = ({ data, fieldsOrder, tabValue, setTabValue, handleTab, selectedItem, children, onmedicationClick, openModal, handleCancleAppointment, appointmentDecision, navigate, handleDeleteReports, list, page, setPage, handleBookAgain, handleForward, setSelectedListItem, handleChatOpen, onCompleteAppointment }) => {
  const history = useHistory();

  const [expandedRow, setExpandedRow] = useState(null);
  const [chatOpen, setChatOpen] = useState(false);
  const [selectedChatUser, setSelectedChatUser] = useState(null);
  const classes = useStyles();
  const appointmentClasses = appointmentStyles();
  const styleClasses = commonMuiStyles()
  const [curr, setCurr] = useState()

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewFile, setPreviewFile] = useState(null);


  const [showPdfPreview, setShowPdfPreview] = useState(false);
  const [pdfData, setPdfData] = useState(null);





  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };


  const getFileType = (url) => {
    if (!url) return 'unknown';
    const lowerUrl = url.toLowerCase();
    if (lowerUrl.includes('.pdf') || lowerUrl.includes('application/pdf')) return 'pdf';
    if (lowerUrl.includes('.png') || lowerUrl.includes('.jpg') || lowerUrl.includes('.jpeg') || lowerUrl.includes('.gif') || lowerUrl.includes('.webp')) return 'image';
    if (lowerUrl.includes('.doc') || lowerUrl.includes('.docx')) return 'document';
    return 'unknown';
  };

  const handlePreviewFile = (item) => {

    if (item.jsonData && Array.isArray(item.jsonData)) {

      setPdfData({
        selectedListItem: item,
        userData: item.doctorInfo,
        prescriptionItems: item.jsonData,
        note: item.notes || item.jsonData.notes || mockNote, // Assuming notes might be a top-level field or inside jsonData
      });
      setShowPdfPreview(true);
    }
    else if (item.fileUrl) {
      setPreviewFile(item);
      setPreviewOpen(true);
    }
  };


  const handleClosePreview = () => {
    setPreviewOpen(false);
    setPreviewFile(null);
  };

  const handleDownloadFromPreview = () => {
    if (previewFile?.fileUrl) {
      const fileName = previewFile.fileName || 'prescription';
      const a = document.createElement('a');
      a.setAttribute('download', fileName);
      a.setAttribute('href', previewFile.fileUrl);
      a.setAttribute('target', '_blank');
      a.click();
    }
  };

  // Tables.js (Near line 160)

  const PdfPreviewDialog = () => {
    const { selectedListItem, userData, prescriptionItems, note } = pdfData || {};

    const handleDownloadPDF = () => {
      const printWindow = window.open('', '_blank');

      // 🔹 MODIFIED HTML for printing
      const html = `
            <html>
            <head>
                <title>Prescription</title>
                <style>
                    body {
                        font-family: 'Times New Roman', Times, serif; /* 🟣 Use a more document-like font */
                        padding: 50px; /* 🟣 Larger padding for document feel */
                        color: #000;
                        line-height: 1.6;
                        margin: 0;
                    }
                    .header {
                        text-align: center;
                        border-bottom: 2px solid #000; /* 🟣 Divider */
                        padding-bottom: 10px;
                        margin-bottom: 30px;
                    }
                    .header h1 {
                        margin: 0;
                        font-size: 24px;
                        color: #1976d2; /* 🟣 Primary color for distinction */
                    }
                    .header p {
                        margin: 5px 0 0 0;
                        font-size: 14px;
                    }
                    .patient-info, .doctor-info {
                        display: flex;
                        justify-content: space-between;
                        margin-bottom: 25px;
                        font-size: 14px;
                    }
                    .section {
                        margin-bottom: 30px;
                        border: 1px solid #ccc; /* 🟣 Container for main sections */
                        padding: 15px;
                        border-radius: 5px;
                    }
                    .section h3 {
                        border-bottom: 1px solid #000;
                        padding-bottom: 5px;
                        margin: 0 0 15px 0;
                        font-size: 18px;
                        color: #333;
                    }
                    .item {
                        border-bottom: 1px dashed #ddd; /* 🟣 Dashed separator for items */
                        padding: 10px 0;
                    }
                    .item:last-child {
                        border-bottom: none;
                    }
                    .item h4 {
                        margin: 0 0 5px 0;
                        font-size: 16px;
                        color: #1976d2;
                    }
                    .item p {
                        margin: 5px 0;
                        font-size: 13px;
                    }
                    .footer {
                        text-align: right; /* 🟣 Signature spot */
                        margin-top: 50px;
                        font-size: 14px;
                    }
                    .signature-line {
                        border-top: 1px solid #000;
                        width: 150px;
                        margin-left: auto;
                        margin-top: 5px;
                    }
                </style>
            </head>
            <body>
                <div class="header">
                    <h1>${userData?.name || 'Medical Clinic Name'}</h1>
                    <p>
                        ${userData?.department || 'General Practitioner'}
                    </p>
                </div>

                <div class="patient-info">
                    <div>
                        
                    </div>
                    <div style="text-align: right;">
                        <strong>Date:</strong> ${moment(selectedListItem?.start_time).format("DD-MM-YYYY")}<br/>
                    </div>
                </div>

                <div class="section">
                    ${prescriptionItems
          ?.map((item, i) => {
            let dosageContent = '';
            if (item.prescriptionType === 'structured' && Array.isArray(item.structuredDose)) {
              dosageContent = `
                                    <p>
                                        <em>Directions:</em> 
                                        M: ${item.structuredDose[0] || 0}, 
                                        N: ${item.structuredDose[1] || 0}, 
                                        E: ${item.structuredDose[2] || 0}, 
                                        T: ${item.structuredDose[3] || 0} &nbsp; | &nbsp; 
                                        Qty: ${item.qty || 'As prescribed'}
                                    </p>
                                `;
            } else if (item.prescriptionType === 'standard') {
              dosageContent = `<p><em>Dosage:</em> ${item.dosage || 'As directed'} | Qty: ${item.qty || 'As prescribed'}</p>`;
            } else if (item.prescriptionType === 'freeText') {
              dosageContent = `<p><em>Instruction:</em> ${item.dosage || 'As prescribed'}</p>`;
            }

            return `
                                <div class="item">
                                    <h4>${i + 1}. ${item.name} (${item.companyName || 'N/A'})</h4>
                                    ${dosageContent}
                                </div>
                            `;
          })
          .join('')}
                </div>

                <div class="section">
                    <h3>Additional Instructions / Follow-up</h3>
                    <p style="white-space: pre-wrap;">${note || 'No specific instructions.'}</p>
                </div>

                <div class="footer">
                    **Dr. ${userData?.name || 'Doctor Name'}**<br/>
                    <div class="signature-line"></div>
                    (Signature)
                </div>

                <script>
                    window.onload = function() {
                        window.print();
                    }
                </script>
            </body>
            </html>
        `;

      // 🔹 Open new print window and write content
      printWindow.document.open();
      printWindow.document.write(html);
      printWindow.document.close();
    };

    return (
      <Dialog open={showPdfPreview} onClose={() => setShowPdfPreview(false)} maxWidth="md" fullWidth>
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Prescription Preview</Typography>
            <IconButton onClick={() => setShowPdfPreview(false)}><CloseOutlined /></IconButton>
          </Box>
        </DialogTitle>
        <Divider />
        <DialogContent sx={{ backgroundColor: '#f0f0f0', p: 0, minHeight: '600px' }}>
          {/* 🟣 MODIFIED: Preview Container to mimic a document */}
          <Box
            sx={{
              m: 4,
              p: 5,
              backgroundColor: '#fff',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              borderRadius: '4px',
              fontFamily: "'Times New Roman', Times, serif", // 🟣 Match document font
              minHeight: '500px'
            }}
          >
            {/* Header */}
            <Box textAlign="center" borderBottom="2px solid #000" pb={1} mb={3}>
              <Typography variant="h5" color="primary" fontWeight="bold">
                {userData?.name || 'Medical Clinic Name'}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {userData?.department || 'General Practitioner'}
              </Typography>
            </Box>

            {/* Patient Info */}
            <Grid container spacing={2} mb={3} fontSize="14px">
              <Grid item xs={6}>

              </Grid>
              <Grid item xs={6} textAlign="right">
                <strong>Date:</strong> {moment(selectedListItem?.start_time).format("DD-MM-YYYY")}<br />
              </Grid>
            </Grid>

            {/* Rx: Medications */}
            <Box sx={{ border: '1px solid #ccc', p: 2, borderRadius: 1, mb: 3 }}>
              {prescriptionItems && prescriptionItems.map((item, idx) => (
                <Box key={idx} sx={{ borderBottom: idx < prescriptionItems.length - 1 ? '1px dashed #ddd' : 'none', pb: 1, pt: 1 }}>
                  <Typography variant="subtitle1" fontWeight="bold" color="primary">
                    {idx + 1}. {item.name} ({item.companyName})
                  </Typography>
                  <Typography variant="body2" sx={{ pl: 1 }}>
                    {/* 🟣 MODIFIED: Added logic for 'standard' and 'freeText' prescription types for preview */}
                    {item.prescriptionType === 'structured' ? (
                      `Directions: M: ${item.structuredDose?.[0] || '0'}, N: ${item.structuredDose?.[1] || '0'}, E: ${item.structuredDose?.[2] || '0'}, T: ${item.structuredDose?.[3] || '0'} | Qty: ${item.qty || 'As prescribed'}`
                    ) : item.prescriptionType === 'standard' ? (
                      `Dosage: ${item.dosage || 'As directed'} | Qty: ${item.qty || 'As prescribed'}`
                    ) : item.prescriptionType === 'freeText' ? (
                      `Instruction: ${item.dosage || 'As prescribed'} | Qty: ${item.qty || 'As prescribed'}`
                    ) : (
                      `Dosage: ${item.dosage || 'N/A'} | Qty: ${item.qty || 'N/A'}`
                    )}
                  </Typography>
                </Box>
              ))}
            </Box>

            {/* Notes */}
            <Box sx={{ border: '1px solid #ccc', p: 2, borderRadius: 1 }}>
              <Typography variant="h6" borderBottom="1px solid #000" pb={0.5} mb={1.5} fontWeight="bold">
                Instructions / Notes
              </Typography>
              <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                {note || 'No specific instructions.'}
              </Typography>
            </Box>

            {/* Doctor Signature */}
            <Box textAlign="right" mt={5}>
              <Typography variant="subtitle1" fontWeight="bold">
                Dr. {userData?.name || 'Doctor Name'}
              </Typography>
              <Box sx={{ borderTop: '1px solid #000', width: '150px', ml: 'auto', mt: 0.5 }}>
                (Signature)
              </Box>
            </Box>

          </Box>
          {/* 🟣 END MODIFIED Preview Container */}
        </DialogContent>
        <DialogActions sx={{ p: 2, borderTop: '1px solid #e0e0e0', backgroundColor: '#fff' }}>
          <Button
            onClick={() => setShowPdfPreview(false)}
            style={{ color: '#666', textTransform: 'none' }}
          >
            Close
          </Button>
          <Button
            onClick={handleDownloadPDF}
            startIcon={<GetApp />}
            style={{ backgroundColor: '#1976d2', color: '#fff', textTransform: 'none' }}
          >
            Download PDF
          </Button>
        </DialogActions>
      </Dialog>
    );
  };


  const getCodeByEnum = (enumValue) => {
        
    const currency = CURRENCIES.find((CURRENCIES) => CURRENCIES.enum === enumValue);
   
    return  currency?currency.symbol:null; // Return null if not found
  };
  useEffect(()=>{
    setCurr(getCodeByEnum(data?.currency))
  },[])


  const handleExpand = (item, index) => {
    if (expandedRow === index) {
      setExpandedRow(null);
    } else {
      setExpandedRow(index);
      selectedItem(item);
    }
  };

  const renderTime = (item) => {
    const availableTimeSlot1 = moment(item?.start_time).format('hh:mm A')
    const availableTimeSlot2 = moment(item?.end_time).add(1, 'seconds').format('h:mm A')
    return (`${availableTimeSlot1} - ${availableTimeSlot2}`)
  }

  const onClickChatButton = () => history.push("/doctor/messages");

  const onMedicationClick = (item) => onmedicationClick(openModal, item);

  const buttonCell = (item) => {
    return <div className={`${classes.cursorStyle} ${classes.textStyle}`}
      onClick={() => openChatDialog(item)}>
      Chat
    </div>
  };

  const medicationCell = (item) => {
    return (
      <div style={{ display: "flex", flexDirection: "column", gap: "6px", alignItems: "flex-start" }}>
        <span
          onClick={() => onMedicationClick(item)}
          style={{
            cursor: "pointer",
            fontSize: 12,
            fontWeight: 500,
            padding: "3px 10px",
            borderRadius: 20,
            border: "1px solid #097eb7",
            color: "#097eb7",
            background: "rgba(9,126,183,0.07)",
            whiteSpace: "nowrap",
            display: "inline-block",
          }}
        >
          Send Prescription
        </span>
        {onCompleteAppointment && (
          <span
            onClick={() => onCompleteAppointment(item)}
            style={{
              cursor: "pointer",
              fontSize: 12,
              fontWeight: 500,
              padding: "3px 10px",
              borderRadius: 20,
              border: "1px solid #2aab6c",
              color: "#2aab6c",
              background: "rgba(42,171,108,0.07)",
              whiteSpace: "nowrap",
              display: "inline-block",
            }}
          >
            Complete
          </span>
        )}
      </div>
    );
  };

  const getAppointmentType = (item) => {
    switch (item.appointment_type) {
      case 0: return "Online";
      case 1: return "In-Clinic";
    }
  }

  const renderStatus = (item) => <span
    className={appointmentClasses.statusStyle}
    style={{ background: getBackgroundColor(item?.status) }}
  >
    {getStatusText(item?.status)}
  </span>

  const getAppointedDoctor = (item) => {
    
    return (<div className={classes.detailCont}>
      {/* <img className={classes.imageStyle} src={item.profile_image?{uri:profile_image}:defaultUserPng} alt="doctor" /> */}
      <div style={{ marginLeft: 8 }}>
        <div>{item.name}</div>
        <div>{item.department}</div>
      </div>
    </div>)
  }

  const getDoctorName = (item) => item.name;

  const handleDownloadReport = (url) => {
    const a = document.createElement('a');
    a.setAttribute('download', 'reactflow.png');
    a.setAttribute('href', url);
    a.click();
  }

  const openChatDialog = (item) => {
    setSelectedChatUser(item);
    setChatOpen(true);
  };

  const closeChatDialog = () => {
    setChatOpen(false);
    setSelectedChatUser(null);
  };

  // Get current user data from localStorage or context
  const getCurrentUser = () => {
    try {
      // Try to get auth data from localStorage (as per user's structure)
      const authData = JSON.parse(JSON.parse(localStorage.getItem('persist:root')).auth);
      if (authData) {
        if (authData.userData) {
          const user = authData.userData;
          return {
            socketId: user._id || user.id || user.userId,
            name: user.name || user.firstName || user.username || 'Current User'
          };
        }
      }

      // Try other common localStorage keys
      const userData = localStorage.getItem('user') || localStorage.getItem('userData') || localStorage.getItem('authUser');
      if (userData) {
        const user = JSON.parse(userData);
        return {
          socketId: user._id || user.id || user.userId,
          name: user.name || user.firstName || user.username || 'Current User'
        };
      }
      
      console.error('No user data found in localStorage, sessionStorage, or token');
      return null;
    } catch (error) {
      console.error('Error getting current user:', error);
      return null;
    }
  };

  const getReceiverFromItem = (item) => {
    
    // Get current user to determine their role
    const currentUser = getCurrentUser();
    const currentUserId = currentUser?.socketId;
    
    // Handle different data structures for doctor vs patient views
    let doctorId, patientId, doctorName, patientName;
    
    // Extract doctor info (handle both string and object formats)
    if (typeof item.doctorId === 'string') {
      // Doctor view: doctorId is string, patientInfo is object
      doctorId = item.doctorId;
      patientId = item.patientInfo?._id;
      doctorName = 'Doctor'; // Not available in this structure
      patientName = item.patientInfo?.name;
    } else {
      // Patient view: patientId is string, doctorInfo is object  
      doctorId = item.doctorInfo?._id;
      patientId = item.patientId;
      doctorName = item.doctorInfo?.name;
      patientName = 'Patient'; // Not available in this structure
    }
    
    // Determine receiver based on current user's role in the appointment
    let receiverId, receiverName, receiverRole;
    
    if (currentUserId === doctorId) {
      // Current user is doctor → message should go to patient
      receiverId = patientId;
      receiverName = patientName || 'Patient';
      receiverRole = 'patient';
    } else if (currentUserId === patientId) {
      // Current user is patient → message should go to doctor  
      receiverId = doctorId;
      receiverName = doctorName || 'Doctor';
      receiverRole = 'doctor';
    } else {
      // Fallback: try to determine from available data
      receiverId = doctorId || patientId;
      receiverName = doctorName || patientName || 'Unknown User';
      receiverRole = 'user';
    }
    
    const receiver = {
      socketId: receiverId,
      _id: receiverId,
      name: receiverName,
      role: receiverRole,
      appointmentId: item._id // Pass the appointment ID for context
    };
    return receiver;
  };

  const renderInvoice = (item) => <IconButton onClick={() => handleDownloadReport(item.invoiceUrl)}><SimCardDownloadOutlined /></IconButton>;

  const renderDoctorAppointmentAction = (item) => (
    <IconButton onClick={() => handlePreviewFile(item)}>
      <Visibility /> 
    </IconButton>
  );


  const getPatientAppointmentAction = (item) => <div className={`${classes.cursorStyle} ${classes.textStyle}`} onClick={() => handleCancleAppointment(item?._id)}>{strings.cancel}</div>;

  const bookAgainAppointmentAction = (item) => <div className={`${classes.cursorStyle} ${classes.textStyle}`} onClick={() => handleBookAgain()}>{strings.bookAgain}</div>;

  const renderReportAction = (item) => <>
    <IconButton onClick={() => handleDownloadReport(item.report)}><SimCardDownloadOutlined /></IconButton>
    {/* {navigate !== 'doctor' && <IconButton onClick={() => handleDeleteReports(item._id)} ><DeleteOutline /></IconButton>} */}
  </>;

  const renderBillingStatus = (item) => {
    switch (item.status) {
      case 0: return <span className={classes.paidStyle}>paid</span>;
      case 1: return <span className={classes.refundStyle}>refund</span>;
      case 2: return <span className={classes.failedStyle}>failed</span>;
    }
  }

  const renderDesignation = (item) => {
    switch(item){
      case 1 : return "Accountant";
    }
  }

  const handleDetails = (item) => {  
    setSelectedListItem(item)
    handleForward();
  }

  const renderTableCell = (key, item, index) => {
    
    if (key === 'actions') {
      return (
        <div className={appointmentClasses.secCont} onClick={() => handleExpand(item, index)}>
        
          <IconButton>
            {expandedRow === index ? (
              <><span className={classes.textStyle}>{strings.hideDetail}</span>
                <ExpandLessIcon className={classes.iconStyle} />
              </>
            ) : (
              <><span className={classes.textStyle}>{strings.viewDetail}</span>
                <ExpandMoreIcon className={classes.iconStyle} />
              </>
            )}
          </IconButton>
        </div>
      );
    }

    const renderEmployeeStatus = (status) =>{
      if(status === 0){ 
        return <span  style={{color:colors.red}}>Inactive</span>
      }
      else if( status ===1){
        return <span style={{color:colors.green}} > Active</span>
      } else { 
        return "Status not available"
      }
    }
    // const renderpatientname =(item)=>{
    //   console.log("itemaapp",item)
    //   alert("hello")
    //   return (<div className={classes.detailCont}>
    //     <img className={classes.imageStyle} src={item.profile_image?{uri:profile_image}:defaultUserPng} alt="doctor" />
    //     <div style={{ marginLeft: 8 }}>
    //       <div>{item.name}</div>
    //       <div>{item.department}</div>
    //     </div>
    //   </div>)
    // }
    const renderIPDaction = (item) => {
      return(<IpdActionCell>
      <div className={`${'delete'} ${'actionButton'}`}>Delete</div>
      <div className={` ${'edit'} ${'actionButton'} `}>Edit</div>     
      </IpdActionCell>)
    }

    if (key === 'accept_decline') {
      return (<> <ButtonStyleContainer>
        <Button className={'accept'} onClick={() => appointmentDecision(item, true)}> Accept </Button>
        <Button className={'decline'} onClick={() => appointmentDecision(item, false)}> Decline</Button>
      </ButtonStyleContainer>
      </>)
    };

    if (key === 'patient_name') return item.patientInfo?.name;
    if (key === 'doctor_appointement_action') return renderDoctorAppointmentAction(item);
    if (key === 'doctor_appointment_slot') return renderTime(item);
    if (key === 'appointment_start_time') return moment(item.start_time).format("DD-MM-YYYY");
    if (key === "medication") return medicationCell(item);
    if (key === 'button') return buttonCell(item);
    if (key === 'pending_amount') return` ${item.currency ? getCodeByEnum(item.currency) : "₹"} ${item.amount}`;
    if (key === 'appointment_type') return getAppointmentType(item);
    if (key === 'doctor_name') return getDoctorName(item);
    if (key === 'updatedAt') return moment(item.updatedAt).format("DD-MM-YYYY h:mm A");
    if (key === 'status') return renderStatus(item);
    if (key === 'profile_image' ) return item.profile_image
    if (key === "appointed_doctor") return getAppointedDoctor(item.doctorInfo);
    if (key === "patient_appointment_start_time") return moment(item.start_time).format("DD-MM-YYYY h:mm A");
    if (key === 'payment_type') return item?.payment_type == "1" ? "Online" : "Offline";
    if (key === 'patient_status') return renderStatus(item);
    if (key === 'patient_appoint_action') return getPatientAppointmentAction(item);
    if (key === 'all_type') return <StyledTypeBox row={item}>{types[item.type]}</StyledTypeBox>;
    if (key === 'doctor_appointement_report_action') return renderReportAction(item);
    if (key === 'createdAt') return moment(item).format('DD-MM-YYYY')
    if (key === 'invoiceUrl') return renderInvoice(item);
    if (key === 'billingStatus') return renderBillingStatus(item);
    if (key === 'book_again_appointment_action') return bookAgainAppointmentAction(item);
    if (key === 'chat_action') return <div className={`${classes.cursorStyle} ${classes.textStyle}`} onClick={() => openChatDialog(item)}>Chat</div>;
    if (key === 'orgActions') return <span onClick={()=> handleDetails(item)} className={`${classes.cursorStyle} ${classes.textStyle}`}>{strings.viewDetail}</span>;
    if (key === 'patient_id') return item.uniqueID;
    if (key === 'patient_contact') return `${item.countryCode}-${item.phoneNumber}`;
    if (key === 'gender') return renderGender(item.gender);
    if (key === 'emergency_name') return item?.emergencyContacts[0]?.name;
    if (key === 'emergency_contact') return !! item?.emergencyContacts[0] ? `+${item?.emergencyContacts[0]?.country_code}-${item?.emergencyContacts[0]?.phone_number}` : '';
    if (key === 'doctor_id') return item._id;
    if (key === 'contact') return `${item?.country_code}-${item?.phone_number}`;
    if (key === 'permission') return renderPermission(item.permission);
    if (key === 'designation') return renderDesignation(item.designation);
    if (key === 'employeeStatus') return renderEmployeeStatus(item.status);
    if (key === 'ipdAction') return renderIPDaction(item); 
    if (key =="actionorg") return <button>Selec</button>
    return item[key];
  };

  return (<>
    <Table>
      <TableHead className={navigate === "scrollable" ? classes.header : ''}>
        <TableRow>
          {Object.values(fieldsOrder).map((heading, index) => (
            <StyledTableCell key={index}>{heading}</StyledTableCell>
          ))}
         

        </TableRow>
      </TableHead>
      <TableBody >
        {data.map((item, index) => (
          
          <React.Fragment key={index}>
            <TableRow className={expandedRow === index ? classes.selectedRow : ''}>
              {Object.keys(fieldsOrder).map((key, i) => (
                
                <StyledTableCell key={i}                                                                                                                                                                                                                                                  >
                  {renderTableCell(key, item, index)}
                </StyledTableCell>
              ))}
                <TableCell align="right">
        {/* <Button variant="contained" color="primary" onClick={() => { console.log('Button clicked!'); }}>
          View Details
        </Button> */}
      </TableCell>
            </TableRow>
            
            {expandedRow === index && (
              <TableRow>
                <StyledTableCell colSpan={Object.keys(fieldsOrder).length}>
                  <Accordion elevation={0}>
                    <AccordionDetails className='custom-accordion-details'>
                      <TabComponent tabs={appointmentTabList} tabValue={tabValue} setTabValue={setTabValue} handleTab={handleTab}
                        customTab={styleClasses.customTab}
                        customTabIndicator={styleClasses.customTabIndicator}
                      />
                      <div className='accordian-detail'>{children} </div>
                    </AccordionDetails>
                  </Accordion>
                </StyledTableCell>
              </TableRow>

            )}
          </React.Fragment>
        ))}
      </TableBody>
    </Table>

    
    {!!list && list?.length > 10 &&
      <ContainerStyle>
        <Pagination
          count={Math.ceil(list.length / 10)}
          page={page}
          showFirstButton
          showLastButton
          onChange={handleChangePage}
        />
      </ContainerStyle>}

    {/* Chat Dialog */}
    <Dialog
      open={chatOpen}
      onClose={closeChatDialog}
      maxWidth="md"
      fullWidth
      PaperProps={{
        style: {
          height: '600px',
          maxHeight: '90vh',
          border: 'none',
          boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
          borderRadius: '12px',
          overflow: 'hidden',
          backgroundColor: 'transparent'
        }
      }}
      style={{
        zIndex: 1300
      }}
    >
      <DialogContent 
        style={{ 
          padding: 0, 
          overflow: 'hidden',
          height: '100%',
          backgroundColor: 'transparent',
          borderRadius: '12px'
        }}
      >
        {selectedChatUser && (
          <ChatInterface
            currentUser={getCurrentUser()}
            onClose={closeChatDialog}
            initialReceiver={getReceiverFromItem(selectedChatUser)}
          />
        )}
      </DialogContent>
    </Dialog>
    <Dialog
      open={previewOpen}
      onClose={handleClosePreview}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        style: {
          height: '90vh',
          maxHeight: '90vh',
          backgroundColor: '#f5f5f5'
        }
      }}
    >
      <DialogTitle style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '1px solid #e0e0e0',
        padding: '16px 24px',
        backgroundColor: '#fff'
      }}>
        <div>
          <div style={{ fontSize: '18px', fontWeight: 600 }}>Prescription Preview (Pdf file not able to preview you need to download it.)</div>
          {previewFile?.fileName && (
            <div style={{ fontSize: '14px', color: '#666', marginTop: '4px' }}>
              {previewFile.fileName}
            </div>
          )}
        </div>
        <IconButton onClick={handleClosePreview} size="small">
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent style={{
        padding: '20px',
        overflow: 'auto',
        backgroundColor: '#f5f5f5',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        {previewFile?.fileUrl && (() => {
          // ✅ CALLING getFileType() function to determine file type
          const fileType = getFileType(previewFile.fileUrl);

          return (
            <>
              {/* ✅ For PDF files */}
              {fileType === 'pdf' && (
                <iframe
                  src={`${previewFile.fileUrl}#toolbar=0`}
                  style={{
                    width: '100%',
                    height: '100%',
                    border: 'none',
                    backgroundColor: '#fff'
                  }}
                  title="Prescription Preview"
                />
              )}

              {/* ✅ For Image files */}
              {fileType === 'image' && (
                <img
                  src={previewFile.fileUrl}
                  alt="Prescription"
                  style={{
                    maxWidth: '100%',
                    maxHeight: '100%',
                    objectFit: 'contain',
                    backgroundColor: '#fff',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    borderRadius: '4px'
                  }}
                  onError={(e) => {
                    console.error('Image failed to load:', previewFile.fileUrl);
                    e.target.style.display = 'none';
                    e.target.parentElement.innerHTML = '<div style="text-align: center; color: #666;">Failed to load image. Please try downloading the file.</div>';
                  }}
                />
              )}

              {/* ✅ For other document types */}
              {(fileType === 'document' || fileType === 'unknown') && (
                <div style={{ textAlign: 'center', padding: '40px' }}>
                  <div style={{ fontSize: '16px', color: '#666', marginBottom: '20px' }}>
                    This file type cannot be previewed directly.
                  </div>
                  <Button
                    onClick={handleDownloadFromPreview}
                    variant="contained"
                    startIcon={<GetApp />}
                    style={{
                      backgroundColor: '#1976d2',
                      color: '#fff',
                      textTransform: 'none',
                    }}
                  >
                    Download File
                  </Button>
                </div>
              )}

              {/* ✅ For unknown file types */}
              {fileType === 'unknown' && (
                <iframe
                  src={previewFile.fileUrl}
                  style={{
                    width: '100%',
                    height: '100%',
                    border: 'none',
                    backgroundColor: '#fff'
                  }}
                  title="File Preview"
                  onError={(e) => {
                    console.error('Failed to load file:', previewFile.fileUrl);
                    e.target.style.display = 'none';
                    e.target.parentElement.innerHTML = '<div style="text-align: center; color: #666; padding: 40px;">Unable to preview this file. Please download it to view.</div>';
                  }}
                />
              )}
            </>
          );
        })()}
      </DialogContent>

      <DialogActions style={{
        padding: '16px 24px',
        borderTop: '1px solid #e0e0e0',
        backgroundColor: '#fff'
      }}>
        <Button
          onClick={handleClosePreview}
          style={{
            color: '#666',
            textTransform: 'none'
          }}
        >
          Close
        </Button>
        <Button
          onClick={handleDownloadFromPreview}
          variant="contained"
          startIcon={<GetApp />}
          style={{
            backgroundColor: '#1976d2',
            color: '#fff',
            textTransform: 'none',
            marginLeft: '8px'
          }}
        >
          Download
        </Button>
      </DialogActions>
    </Dialog>

    {showPdfPreview && pdfData && <PdfPreviewDialog />}
  </>
  );
};

export default Tables;
